/* eslint-disable no-magic-numbers */
import React from 'react';

import mainConfig from '../../../../config/main';

/**
   * Generate Header Entities based on the sheet a user selects
   *
   * @param {{}} sheet
   * @param {{width: number, height: number}} resolution
   * @returns {*}
   */
const generateSheetHeaderEntities = (sheet, resolution) => {
  const sheetHeaders = sheet.headers;
  if (!sheet || !sheetHeaders) {
    return [];
  }

  const textAndImageHeaders = sheetHeaders.filter((sheetHeader) => ['string', 'image'].includes(sheetHeader.type));
  const numberOfEntities = textAndImageHeaders.length;
  const HALF_OF_ENTITY_WIDTH = 200;
  const X_POSITION = (resolution.width / numberOfEntities - HALF_OF_ENTITY_WIDTH);
  const Y_POSITION = 440;

  return textAndImageHeaders.map((sheetHeader, idx) => {
    const baseEntity = {
      name: sheetHeader.header,
      type: `sheet|${sheetHeader.type}|${sheetHeader.header}|${sheet.id}`,
      size: {width: 300, height: 150},
      position: {x: X_POSITION * (idx + 1), y: Y_POSITION},
    };

    if (sheetHeader.type === 'image') {
      return {
        ...baseEntity,
        entityType: 'feedimage',
        url: `${mainConfig.assets.imagePlaceholderUrl}`,
      };
    }

    return {
      ...baseEntity,
      entityType: 'feed',
      markdown: `{|}{$1.00}{%1}{100}{#ffffff}{poppinsbold}${sheetHeader.header}{!poppinsbold}{!#ffffff}{!100}{!%1}{!$1.00}{!|}`
    };
  });
};

/**
   * Renders the sheet feed card.
   * @param {{}} sheet
   *
   * @returns {{}}
   */
const parseSheetToCard = (sheet) => {
  const textAndImageHeaders = sheet.headers.filter((sheetHeader) => ['string', 'image'].includes(sheetHeader.type));
  const numberOfEntitiesToShow = textAndImageHeaders.length > 4 ? 3 : textAndImageHeaders.length - 1;

  if (sheet.thumbnailUrl) {
    return (
      <img
        src={sheet.thumbnailUrl}
        alt={`${sheet.name} thumbnail`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    );
  }

  return (
    <table className="table">
      <tbody>
        {(textAndImageHeaders.slice(0, numberOfEntitiesToShow)).map((sheetHeader) => (
          <tr key={sheetHeader.header}>
            <td className="h6">{sheetHeader.header}</td>
          </tr>)
        )}
      </tbody>
    </table>
  );
};

export {
  generateSheetHeaderEntities,
  parseSheetToCard,
};

